import {
  Card,
  Row,
  Col,
  Button,
  Spin,
  Modal,
  message,
  Empty,
  Segmented,
} from "antd";
import "../index.css";
import { PlusOutlined } from "@ant-design/icons";
import PostFormDrawer from "./PostFormDrawer";
import { useEffect, useState } from "react";
import postService from "../../../services/postService";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
const { confirm } = Modal;

const { Meta } = Card;

const PostManagement = (props) => {
  const [openPostForm, setOpenPostForm] = useState(false);
  const [postFormData, setPostFormData] = useState(null);
  const [type, setType] = useState("BLOG");
  const [posts, setPosts] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    handleLoadData();
  }, [type]);

  const handleLoadData = () => {
    setIsLoading(true);
    postService
      .getPosts({ type })
      .then((data) => {
        setPosts(data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        messageApi.open({
          type: "error",
          content: error,
        });
      });
  };

  const handleCloseModal = () => {
    setOpenPostForm(false);
    setPostFormData(null);
  };

  const handleEditPost = (data) => {
    setOpenPostForm(true);
    setPostFormData(data);
  };
  const handleCreatePost = () => {
    setOpenPostForm(true);
  };

  const handleChangeType = (value) => {
    setType(value);
  };

  const showDeleteConfirm = (slug) => {
    confirm({
      title: "Are you sure delete this post?",
      icon: <ExclamationCircleFilled />,
      content: slug,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        postService
          .deletePost(slug)
          .then(() => {
            handleLoadData();
            messageApi.open({
              type: "success",
              content: "The post has been deleted!",
            });
          })
          .catch((error) => {
            messageApi.open({
              type: "error",
              content: error,
            });
          });
      },
      onCancel() {},
    });
  };

  const handleSuccess = (type) => {
    messageApi.open({
      type: "success",
      content: `The post has been ${
        type === "Create" ? "created" : "updated"
      }!`,
    });
    handleLoadData();
    handleCloseModal();
  };

  return (
    <>
      {contextHolder}
      {openPostForm && (
        <PostFormDrawer
          onClose={handleCloseModal}
          onSuccess={handleSuccess}
          data={postFormData}
        />
      )}
      <Segmented
        value={type}
        onChange={handleChangeType}
        options={[
          { value: "BLOG", label: "Blog" },
          { value: "MY_WORKS", label: "My works" },
        ]}
      />
      <Button
        type="primary"
        className="float-right"
        icon={<PlusOutlined />}
        onClick={handleCreatePost}
      >
        Create Post
      </Button>

      <Spin tip="Loading..." spinning={isLoading}>
        <Row gutter={[16, 16]} className="mt-16" style={{ minHeight: 300 }}>
          {!posts?.[0] && !isLoading && (
            <Col span={24}>
              <Empty style={{ marginTop: 100 }} />
            </Col>
          )}
          {posts &&
            posts.map((item) => {
              return (
                <Col key={item.slug} span={6} className="post-container">
                  <Card
                    size="small"
                    hoverable
                    cover={
                      <img
                        alt="example"
                        src={item?.image?.url}
                        style={{
                          height: 200,
                          backgroundColor: "#ccc",
                          objectFit: "cover",
                        }}
                      />
                    }
                    actions={[
                      item.isPublishing ? (
                        <EyeOutlined style={{ color: "blue" }} />
                      ) : (
                        <EyeInvisibleOutlined style={{ color: "blue" }} />
                      ),
                      <EditOutlined
                        key="edit"
                        onClick={() => handleEditPost(item)}
                      />,
                      <DeleteOutlined
                        key="ellipsis"
                        onClick={() => showDeleteConfirm(item.slug)}
                      />,
                    ]}
                  >
                    <Meta title={item.title} />
                  </Card>
                </Col>
              );
            })}
        </Row>
      </Spin>
    </>
  );
};

export default PostManagement;
